export enum DocumentType {
  Payslip = 'payslip',
  ExpenseNote = 'expenseNote',
  HealthInsuranceCertificate = 'healthInsuranceCertificate',
  TaxCertificate = 'taxCertificate',
  CriminalRecord = 'criminalRecord',
}

/**
 * This array contains the document types that monitors are allowed to upload
 */
export const monitorUploadDocumentTypes = [
  DocumentType.CriminalRecord,
] as const;
